import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { APIURI } from "../config";
import Loader from "../utils/Loader";

// Landing page for a scanned Team-via-QR code. Joins the guest to the team via
// the backend, stores the returned access token exactly like a normal login,
// then hands off to the existing /pods:<gameID> flow (PodStory.jsx), which
// already knows how to land a team member on PodStartStory.
const TeamQrJoin = () => {
  const params = useParams();
  const { gameID, teamId } = params;
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const existingToken = localStorage.getItem("accesstoken");
    const config = existingToken
      ? { headers: { Authorization: `Bearer ${existingToken}` } }
      : {};

    axios
      .post(`${APIURI}/web-team-qr/join/${gameID}/${teamId}`, {}, config)
      .then((res) => {
        localStorage.setItem("accesstoken", res.data.accessToken);
        window.location.href = `/pods:${gameID}`;
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          window.location.href = `/auth:pod:${gameID}/0`;
        } else {
          setErrorMessage(
            err?.response?.data?.message || "Unable to join team. Please try again."
          );
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (errorMessage) {
    return (
      <div style={{ padding: "2em", textAlign: "center" }}>
        <h2>Unable to join team</h2>
        <p>{errorMessage}</p>
      </div>
    );
  }

  return <Loader />;
};

export default TeamQrJoin;
